import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeText } from 'src/shared/models/textResource.model';

const {
  TEXT_BODY,
  TEXT_DESKTOP_IMAGE,
  TEXT_MOBILE_IMAGE,
  TEXT_IMAGE_POSITION,
} = ResourceTypeDetailEnum;

export const buildChallengeText = (resource: IResourceList): IChallengeText => {
  const { resourceDetailList, idResource, name: title } = resource;
  let item: IChallengeText;

  let imagePosition: string;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case TEXT_BODY:
          item = {
            ...item,
            description: value,
          };
          break;
        case TEXT_DESKTOP_IMAGE:
          item = {
            ...item,
            imageDesktop: value,
          };
          break;
        case TEXT_MOBILE_IMAGE:
          item = {
            ...item,
            imageMobile: value,
          };
          break;
        case TEXT_IMAGE_POSITION:
          imagePosition = value;
          break;
      }
    });

  item.imagePosition =
    item.imageDesktop || item.imageMobile ? imagePosition || 'left' : null;

  return {
    ...item,
    idResource,
    title,
  };
};
